import * as Sentry from '@sentry/browser';

import IUserToken from '../interfaces/tokens/userToken';
import { ENV } from '../settings';

export class LogService {
  constructor() {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_KEY || '',
      environment: ENV,
      sampleRate: 0.25,
      release: '4b0c9419ab',
    });
  }

  public setUser(user: IUserToken): void {
    if (!user) {
      Sentry.setUser({
        id: null,
        email: null,
        username: null,
        cli_cod: null,
        extra: {},
      });
      return;
    }

    Sentry.setUser({
      id: user.id?.toString(),
      email: user.email,
      username: user.name,
      cli_cod: user.cli_cod,
      extra: { ...user },
    });
  }

  public handleError(err: any): void {
    if (!err) return;

    if (typeof err === 'string') {
      err = new Error(err);
    }

    Sentry.captureException(err);
  }
}

const logService = new LogService();
export default logService;
